import { render } from "./SitesSwiper.vue?vue&type=template&id=03119d53&scoped=true"
import script from "./SitesSwiper.vue?vue&type=script&lang=js"
export * from "./SitesSwiper.vue?vue&type=script&lang=js"

import "./SitesSwiper.vue?vue&type=style&index=0&id=03119d53&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-03119d53"

export default script